export default "__VITE_ASSET__Bx1_o$5M__"